import { Component, OnInit, ViewChild } from '@angular/core';
import { ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { MessageService } from 'primeng/api';
import { ICategoryOut } from 'src/app/shared/interfaces/categoryOut';
import { IDoctor } from 'src/app/shared/interfaces/doctor';
import { EGender } from 'src/app/shared/interfaces/gender-enum';
import { UserStatus } from 'src/app/shared/interfaces/userStatus-enum';
import { ModalComponent } from 'src/app/shared/modals/modal.component';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-account-info',
  templateUrl: './account-info.component.html',
  styleUrl: './account-info.component.css'
})
export class AccountInfoComponent implements OnInit {

  drID: any = null;
  drInfo: IDoctor = {
    id: 7,
    name: "",
    family: '',
    meliCode: '',
    medicalEspertiseId: 0,
    medicalEspertiseName: '',
    status: 1,
    profilePic: '',
    img: null,
    gender: 1,
    codeNo: '',
    tel: '',
    mobile: '',
    birthDate: 0,
    sheba: '',
    bank: '',
    card: '',
    accountNo: '',
    workAddress: '',
    aboutMe: '',
    officeEquipment: '',
    imgFile: null,
    tags: [] = [],
    lags: [] = [],
    isActiveAttendanceVisit: false,
    experience: 1390,
    birthDatePlace: '',
    email: '',
    education_s: '',
    workPlace: ''
  };

  categoriesList: ICategoryOut[];
  genderEnum = EGender;
  keywords: string;  
  selectedData: any;
  lang: any;
  userState = UserStatus;


  constructor(
    public apiService: ApiService,
    private messageService: MessageService
  ) {}


  ngOnInit(): void {
    this.getCategoriesList();
    this.getDotorInfo();

  }

  updateDoctorInfo() {    

    if(this.drInfo.medicalEspertiseId == null || this.drInfo.medicalEspertiseId == 0) {
      this.messageService.add({severity: 'error', summary: 'خطا', detail: 'لطفا فیلد های ضروری را تکمیل کنید' });
      return
    }

    var dr = new FormData();
    dr.append('IMGFile', this.drInfo.imgFile);
    dr.append('tel', this.drInfo.tel);
    dr.append('name', this.drInfo.name);
    dr.append('family', this.drInfo.family);
    dr.append('Gender', this.drInfo.gender.toString());
    dr.append('MedicalEspertiseId', this.drInfo.medicalEspertiseId.toString());
    dr.append('workAddress', this.drInfo.workAddress);
    dr.append('officeEquipment', this.drInfo.officeEquipment);
    dr.append('aboutMe', this.drInfo.aboutMe);
    dr.append('isActiveAttendanceVisitAdd', this.drInfo.isActiveAttendanceVisit.toString());
    dr.append('bank', this.drInfo.bank);
    dr.append('accountNo', this.drInfo.accountNo);
    dr.append('card', this.drInfo.card);
    dr.append('sheba', this.drInfo.sheba);
    dr.append('Email', this.drInfo.email);
    dr.append('CodeNo', this.drInfo.codeNo);
    dr.append('WorkPlace', this.drInfo.workPlace);
    dr.append('Education_s', this.drInfo.education_s);
    dr.append('BirthDatePlace', this.drInfo.birthDatePlace);
    dr.append('BirthDate', this.drInfo.birthDate!=null?this.drInfo.birthDate.toString():'0');
    dr.append('MeliCode', this.drInfo.meliCode);
    dr.append('Experience', this.drInfo.experience?this.drInfo.experience.toString():'0');
    
    if(this.drInfo.lags != null && this.drInfo.lags.length > 0){
      let tempLang: string = this.drInfo.lags.join(" // ");
      dr.append('lagsAdd', tempLang);
    }
    if(this.drInfo.tags != null && this.drInfo.tags.length > 0){
      let tempTag: string = this.drInfo.tags.join(" // ");
      dr.append('tagsAdd', tempTag);
    }
    
    // dr.append('IMGFile', this.drInfo.imgFile);

    // Display the key/value pairs
    for (var pair of dr.entries()) {
      console.log(pair[0]+ ', ' + pair[1]); 
    }

    this.apiService.callFormDataApi('/api/Doctor/Edit', dr).subscribe((res: any) => {
      console.log(res);
      
      if (res.body.isSuccess == true) {
        this.messageService.add({severity: 'success', summary: 'موفق', detail: 'تغییرات با موفقیت اعمال شد.' });
      } else {
        this.messageService.add({severity: 'error', summary: 'خطا', detail: res.body.message });
      }
    })
  }

  addLangArray() {
    if(this.lang == undefined || this.lang == null || this.lang == ''){
      this.messageService.add({severity: 'error', summary: 'خطا', detail: 'لطفا فیلد ها را با مقادیر مناسب تکمیل کنید' });
      return
    }

    this.drInfo.lags = this.drInfo.lags || [];
    this.drInfo.lags.push(this.lang);
    console.log(this.drInfo.lags);
    
    this.lang = '';
  }

  addTagArray() {
    if(this.keywords == undefined || this.keywords == null || this.keywords == ''){
      this.messageService.add({severity: 'error', summary: 'خطا', detail: 'لطفا فیلد ها را با مقادیر مناسب تکمیل کنید' });
      return false
    }

    this.drInfo.tags = this.drInfo.tags || [];
    
    this.drInfo.tags.push(this.keywords);
    console.log(this.drInfo.tags);
    
    this.keywords = '';
  }

  deleteLangs(exp) {
    const temp = this.drInfo.lags.filter(item => item != exp);
    this.drInfo.lags = temp;
  }

  deleteTags(exp) {
    const temp = this.drInfo.tags.filter(item => item != exp);
    this.drInfo.tags = temp;
  }

  getCategoriesList() {
    this.apiService.apiCall('post', '/api/Category/GetAll/2/0', {pagesize:200}).subscribe((res: any) => {
      console.log(res);
      this.categoriesList = res.body.model;
    })
  }

  getDotorInfo() {
    this.apiService.apiCall('get', '/api/Doctor/Get' ).subscribe((res: any) => {
      console.log(res);
      
      this.drInfo = res.body.model;
      this.url = this.apiService.api + res.body.model.profilePic;
    })
  }

  @ViewChild('modal') modal!: ModalComponent;
  collapseShow = "hidden";

  heartDis: boolean;
  lungDis: boolean;
  url: any;

  // -------------------Image----------------
  // file: any;
  localUrl: File = null;
  localCompressedURl: any;
  sizeOfOriginalImage: number;
  sizeOFCompressedImage: number;
  imgResultBeforeCompress: string;
  imgResultAfterCompress: string;
  showCropper = false;
  imageChangedEvent: File = null;
  croppedImage: any;

  onItemChange(value) {
    console.log(" Value is : ", value);
  }

  onDateSelected(date: string) {
    console.log('Selected date:', date);
    this.selectedData = date;
  }

  ////////////////////////// Managing profile image

  onSelectFile(event) {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      this.drInfo.imgFile = input.files[0];
    }

    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]); // read file as data url

      reader.onload = (event1) => { // called once readAsDataURL is completed
        // this.drInfo.img = event1.target.result;
        this.url = event1.target.result;       

      }
      // this.imageChangedEvent = event;
      // this.modal.open();
    }

  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    console.log(event);
    

  }
  imageLoaded(image: LoadedImage) {
    this.showCropper = true;
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }
}
